<script lang="ts">
	import type { Post } from '$lib/api/rpc';
	export let block: Post;
	export let inComposer = false;

	const align = block.etc.align || 'full';
</script>

<div class={align}>
	{#if block.etc && block.etc.link_url}
		<a target="_blank" rel="noreferrer" href={block.etc.link_url}>
			<img
				height={block.title_image?.height}
				width={block.title_image?.width}
				src={block.title_image?.url}
				alt={block.title_image?.alt_text ? block.title_image?.alt_text : block.title} />
		</a>
	{:else}
		<img
			height={block.title_image?.height}
			width={block.title_image?.width}
			src={block.title_image?.url}
			alt={block.title_image?.alt_text ? block.title_image?.alt_text : block.title}
			aria-label={block.title_image?.alt_text ? block.title_image?.alt_text : block.title} />
	{/if}
	{#if block.description && !inComposer}
		<div class="captionContainer">
			{block.description}
		</div>
	{/if}
</div>

<style>
	img {
		display: block;
		block-size: auto;
		max-inline-size: 100%;
		margin: auto;
	}

	.left {
		inline-size: 50%;
		margin-inline-end: 18px;
		float: left;
	}

	.right {
		inline-size: 50%;
		margin-inline-start: 18px;
		float: right;
	}

	.captionContainer {
		display: inline-block;
		position: relative;
		inline-size: 100%;
		padding-inline: 5px;
		color: rgb(83 90 99);
		font-size: 13px;
		font-weight: 300;
		text-align: center;
	}

	.captionContainer::after {
		content: '';
		position: absolute;
		block-size: 1px;
		inline-size: 80px;
		margin-inline-start: -40px;
		background-color: rgb(231 231 231);
		inset-block-start: 24px;
		inset-inline-start: 50%;
	}
</style>
